<template>
  <div class="top-nav-wrapper">
    <div class="top-nav-inner-wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    setTimeout(() => {
      const stickyHeader = $(this.$el)

      stickyHeader.stickySidebar({
        topSpacing: 0,
        bottomSpacing: 0,
        containerSelector: '.sticky-nav-container',
        innerWrapperSelector: '.sidebar__inner'
      })

      stickyHeader.navpoints()
    }, 1000)
  }
}
</script>

<style scoped>
.top-nav-wrapper {
  margin-top: -5rem;
  border-bottom: 1px solid #e0e0e0;
  background: white;
  pointer-events: none;
  transition: opacity 0.2s ease;
  opacity: 0;
  z-index: 100;
  position: relative;
}

.top-nav-wrapper.is-affixed {
  opacity: 1;
  pointer-events: all;
}

.top-nav-wrapper ul {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}

ul.top-nav::after {
  content: '';
  position: absolute;
  bottom: 0;
  height: 1px;
  background: var(--black-light-2);
  left: -1000px;
  right: -1000px;
}
</style>

<style>
ul.top-nav {
  display: flex;
  align-items: center;
  background: white;
  height: 80px;
}

ul.top-nav li {
  margin-bottom: 0;
}

ul.top-nav .top-nav-link {
  margin-right: 32px;
  position: relative;
  display: block;
  color: #222222;
  height: 100%;
  white-space: nowrap;
  font-weight: 500;
  line-height: 80px;
}

ul.top-nav .top-nav-link.hidden {
  display: none;
}

ul.top-nav .top-nav-link.active {
  color: var(--secondary);
  position: relative;
}

ul.top-nav .top-nav-link.active::after {
  content: '';
  position: absolute;
  height: 3px;
  bottom: -1px;
  right: -0px;
  left: -0px;
  background: var(--secondary);
  z-index: 100;
}
</style>